export default "__VITE_ASSET__C2L276sK__"